/**
 * Collection Page Auto-Scroll
 *
 * When users click on a product category link (with ?scroll=content parameter),
 * automatically scrolls past the hero banner to show the category content.
 *
 * Direct URL access or page refresh starts from the top as normal.
 */

(function () {
  'use strict';

  // Only run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initCollectionScroll();
    initLinkInterception();
  }

  /**
   * Handle scroll on page load if parameter is present
   */
  function initCollectionScroll() {
    // Check for scroll parameter
    const urlParams = new URLSearchParams(window.location.search);
    const shouldScroll = urlParams.get('scroll') === 'content';

    if (!shouldScroll) return;
    cleanUpUrl();

    // Find the target element to scroll to
    const targetElement = document.getElementById('collection-content');

    if (!targetElement) {
      // Target not found - this might not be a collection page with the page-title section
      return;
    }

    // Small delay to ensure page is fully rendered
    requestAnimationFrame(() => {
      // Calculate scroll position with offset for sticky header if present
      const headerHeight = getHeaderHeight();
      const targetPosition =
        targetElement.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        20;

      // Perform smooth scroll
      window.scrollTo({
        top: Math.max(0, targetPosition),
        behavior: 'smooth',
      });
    });
  }

  /**
   * Intercept clicks on collection links and add scroll parameter
   * This handles navigation menu links and other collection links that don't go through card-collection snippet
   */
  function initLinkInterception() {
    document.addEventListener('click', function (e) {
      // Find the clicked link (might be a child element of the anchor)
      const link = e.target.closest('a[href]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      // Check if this is a collection link
      if (isCollectionLink(href)) {
        // Don't modify if it already has scroll parameter
        if (href.includes('scroll=content')) return;

        // Don't modify external links
        if (href.startsWith('http') && !href.includes(window.location.hostname))
          return;

        // Add scroll parameter to the link
        e.preventDefault();
        const separator = href.includes('?') ? '&' : '?';
        window.location.href = href + separator + 'scroll=content';
      }
    });
  }

  /**
   * Check if a URL is a collection page link
   */
  function isCollectionLink(href) {
    // Match /collections/something but not /collections (the list page)
    // Also match relative URLs
    const collectionPattern = /\/collections\/[^\/\?#]+/;
    return collectionPattern.test(href);
  }

  /**
   * Get the height of sticky header if present
   */
  function getHeaderHeight() {
    const stickyHeader = document.querySelector('sticky-header');
    const header =
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');

    if (stickyHeader) {
      return stickyHeader.offsetHeight || 0;
    }

    if (header) {
      const headerStyle = window.getComputedStyle(header);
      if (
        headerStyle.position === 'fixed' ||
        headerStyle.position === 'sticky'
      ) {
        return header.offsetHeight || 0;
      }
    }

    return 0;
  }

  /**
   * Remove scroll parameter from URL without triggering page reload
   */
  function cleanUpUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('scroll');

    // Use replaceState to update URL without adding to history
    const cleanUrl = url.pathname + (url.search || '') + url.hash;
    window.history.replaceState({}, document.title, cleanUrl || url.pathname);
  }
})();
